import api from '@/services/api'

export default {
  state: {},

  mutations: {},

  actions: {
    async getModules({ commit }) {
      try {
        const response = await api.get(`/modules`)

        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },
  },

  getters: {},
}
